import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as ExternalLinkIcon } from '@pkg/assets/icons/v2/nft-manager-external.svg';

import { Interior, ReportAnIssueWrapper } from './styles';

const NEW_ISSUE_URL = 'https://support.y.at/home';

export function ReportAnIssueAction() {
    const { t: translate } = useTranslation(['common']);

    return (
        <ReportAnIssueWrapper>
            <a href={NEW_ISSUE_URL} target="_blank" rel="noopener noreferrer">
                <Interior>
                    {translate('report_an_issue')}
                    <ExternalLinkIcon />
                </Interior>
            </a>
        </ReportAnIssueWrapper>
    );
}
